import { Box } from "@raca2022/uikit";
import styled from "styled-components";
import BgGetStarted from "../../../assets/img/Langding/BgGetStarted.png";

export const Wapper = styled(Box)`
  width: 100%;
  padding-top: 485px;
  position: relative;
  z-index: 3;
  :after{
    content: "";
    width: 100%;
    height: calc(100% - 1000px);
    top: 1000px;
    background-color: #fff;
    left: 0px;
    position: absolute;
    z-index: -10;
  }
  @media only screen and (max-width: 1024px){
    padding-top: 47.36vw;
  }
  @media only screen and (max-width: 820px){
    padding-top: 50.36vw;
  }
  @media only screen and (max-width: 640px){
    padding-top: calc(55.36vw);
  }
  @media only screen and (max-width: 540px){
    padding-top: 60.36vw;
  }
  @media only screen and (max-width: 440px){
    padding-top: 65.36vw;
  }
  @media only screen and (max-width: 375px){
    padding-top: 70.36vw;
  }
`;
export const GetStarted = styled(Box)`
  width: 100%;
  height: 70vw;
  max-height: 725px;
  background-image: url("${BgGetStarted}");
  padding-top: 256px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  // background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  button {
    font-weight: 600;
    font-size: 18px;
    line-height: 110%;
    background: #144456;
    box-shadow: 2px 4px 6px rgba(15, 46, 57, 0.23);
    border-radius: 10px;
    border: none;
    outline: none;
    color: #fff;
    width: 23vw;
    max-width: 221px;
    min-width: 98px;
    height: 6.3vw;
    max-height: 56px;
    min-height: 27px;
    transition: box-shadow 0.3s linear;
    :active{
        transform: translateY(3%);
    }
    :hover{
        box-shadow: 4px 8px 12px rgba(15, 46, 57, 0.63);
    }
  }
  @media only screen and (min-width: 1920px) {
    padding-top: 256px;
  }
  @media only screen and (max-width: 1024px){
    background-size: 172%;
    padding-top: 30%;
  }
  @media only screen and (max-width: 768px){
    button{
      font-size: 2.34vw;
    }
  }
  @media only screen and (max-width: 428px){
    button{
      font-size: 9px;
    }
  }
`;
